import { useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Cart from "./pages/Cart";
import Login from "./pages/Login";
import Profile from "./pages/Profile";

function App() {
  const [user, setUser] = useState(() => {
    try {
      const stored = localStorage.getItem("user");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  // ✅ backend add to cart
  const addToCart = async (product) => {
    if (!user) {
      alert("Login first");
      return;
    }

    try {
      await fetch("https://ecommerce-backend-ya7x.onrender.com/api/cart", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          userId: user._id,
          product,
        }),
      });

      alert("Added to cart");
    } catch (err) {
      console.log(err);
      alert("Error adding to cart");
    }
  };

  const handleSetUser = (userData) => {
    setUser(userData);
    if (userData) {
      localStorage.setItem("user", JSON.stringify(userData));
    } else {
      localStorage.removeItem("user");
    }
  };

  return (
    <BrowserRouter>
      <Navbar user={user} setUser={handleSetUser} />

      <Routes>
        {/* ✅ no frontend cart */}
        <Route path="/" element={<Home addToCart={addToCart} />} />

        <Route path="/login" element={<Login setUser={handleSetUser} />} />

        <Route path="/profile" element={<Profile user={user} setUser={handleSetUser} />} />

        {/* ✅ cart from backend */}
        <Route
          path="/cart"
          element={user ? <Cart /> : <Navigate to="/login" replace />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;